import safeInnerHTML from '../../../util/safeInnerHTML';

export default class Countdown {
  constructor(element){
    this._element = element;
    this._elementDays = element.querySelector('[data-countdown-days]');
    this._elementHours = element.querySelector('[data-countdown-hours]');
    this._elementMinutes = element.querySelector('[data-countdown-minutes]');
    this._elementSeconds = element.querySelector('[data-countdown-seconds]');
    this._textDays = element.querySelector('[data-countdown-days-text]');
    this._countdownEnabled = element.dataset.countdownEnabled;

    this._endTime = +element.dataset.countdownInitDate; // timestamp in seconds

    if (this._countdownEnabled) {
      this.init();
    }
  }

  init() {
    if (this._countdownEnabled === "False") return;
    if (this._endTime < 0 || this._endTime < moment().unix()) return;

    let duration = this._endTime - moment().unix();

    this._duration = moment.duration(duration, 'seconds');

    this.updateTimer();

    this._timer = setInterval(::this.updateTimer, 1000);
  }

  updateTimer() {
    this._duration = moment.duration(this._duration.asSeconds() - 1, 'seconds');

    safeInnerHTML(this._textDays, this._duration.days() <= 1 ? 'Day' : 'Days');
    safeInnerHTML(this._elementDays, this._duration.days());
    safeInnerHTML(this._elementHours, ('0' + this._duration.hours()).slice(-2));
    safeInnerHTML(this._elementMinutes, ('0' + this._duration.minutes()).slice(-2));
    safeInnerHTML(this._elementSeconds, ('0' + this._duration.seconds()).slice(-2));

    if (this._duration.asSeconds() <= 0) {
      clearInterval(this._timer);
      this._element.remove();
    }
  }

}
